import { apiStaticUrlGet } from "common/api/api_common";
import {
  PHOTO_SIZE_TYPE,
  PhotoSizeType,
} from "constant/photo_series/photo_series.constant";
import {
  PHOTO_SERIES_TYPES,
  PhotoSeriesType,
} from "constant/photo_series/photo_series_type.constant";
import ObjCommon from "model/common/ObjCommon";
import { PhotoInfo } from "./PhotoInfo";

export class PhotoSeries extends ObjCommon {
  name: string = "";
  slug: string = "";
  desc: string = "";
  group: string = "";
  represent: PhotoInfo | null = null;
  sType: PhotoSeriesType = PHOTO_SERIES_TYPES.FOTOGRAFIJE;
  sOrd: number = 0;
  fold: string = "";
  photos: PhotoInfo[] = [];

  constructor(args: Partial<PhotoSeries> = {}) {
    super(args?.id);

    this.name = args?.name ?? "";
    this.slug = args?.slug ?? "";
    this.desc = args?.desc ?? "";
    this.group = args?.group ?? "";
    this.represent = args?.represent ?? null;
    this.sType = args?.sType ?? PHOTO_SERIES_TYPES.FOTOGRAFIJE;
    this.sOrd = args?.sOrd ?? 0;
    this.fold = args?.fold ?? "";
    this.photos = args?.photos
      ? PhotoInfo.photoInfosFromArray(args.photos)
      : [];
  }

  getShortSType(): string {
    return this.sType === "fotografije" ? "ph" : "ng";
  }

  getRepresents(): string[] {
    let photoN: string[] = [];
    if (this.represent !== null && this.represent.middle) {
      photoN.push(this.represent.middle);
    }
    const maxN = Math.min(4, this.photos.length);
    for (let i = 0; i < maxN; i++) {
      const ph = this.photos[i].small;
      if (
        !photoN.includes(this.photos[i].name) &&
        !photoN.includes(this.photos[i].middle) &&
        !photoN.includes(this.photos[i].small)
      ) {
        photoN.push(ph);
      }
      if (photoN.length >= maxN) {
        break;
      }
    }

    return photoN;
  }

  getPhotoStaticUrl(
    ind: number,
    sizeType: PhotoSizeType = PHOTO_SIZE_TYPE.LARGE,
  ): string {
    return this.photos[ind].getPhotoStaticUrl(this.fold, sizeType);
  }
}
